module.exports = __webpack_public_path__ + "img/credits.9c686775.png";